
const INITIAL_STATE = { status: false }

const ControlCloseModalUrl = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'PRODUCT_CONTROL_CLOSE_MODAL_URL_CHANGE':
            return { status: action.payload }
        default:
            return state;
    }
}

export default ControlCloseModalUrl